module.exports = __webpack_public_path__ + "apple-touch-icon.c121dd49.png";


//////////////////
// WEBPACK FOOTER
// ./client/containers/App/apple-touch-icon.png
// module id = 638
// module chunks = 0